import { useMutation, useQueryClient } from "@tanstack/react-query";
import { axios } from "../../../shared/lib/axios";
import _cookies from "../../../shared/utils/_cookies";

export const addUserToCloseFriends = async (data) => {
  const body = new FormData();

  body.append(
    "dados",
    `[${JSON.stringify({
      alunoid: _cookies.getItem("auth").user.alunoid,
      alunoidFavorito: data.studentId,
      operacao: data.addUser ? "I" : "E",
    })}]`
  );

  const res = await axios.middleware.post("/Social.asmx/Favoritos", body);
};

export const useAddUserToCloseFriends = ({ config } = {}) => {
  const queryClient = useQueryClient();
  return useMutation({
    ...config,
    mutationFn: addUserToCloseFriends,
    onSuccess: (data, variables) => {
      console.log("successo");
      queryClient.invalidateQueries({
        queryKey: ["socialMediaUser", { studentId: variables.studentId }],
      });
      queryClient.invalidateQueries({ queryKey: ["socialMediaUserContacts"] });
    },
  });
};
